import { KNOWLEDGE_BASE_SOURCE } from '@trustero/trustero-api-web/lib/questionnaire/questionnaire_pb'
import { ParseColumnType } from 'src/Utils/csv/csv.constants'

export const getKnowledgeBaseParsers = (): ParseColumnType => ({
  question: {
    validator: (_c, _v, _r) => null,
    mutator: (value) => value,
  },
  answer: {
    validator: (_c, _v, _r) => null,
    mutator: (value) => value,
  },
})

export const getKnowledgeBaseSource = (source: KNOWLEDGE_BASE_SOURCE): string =>
  source === KNOWLEDGE_BASE_SOURCE.UPLOAD
    ? 'Upload'
    : source === KNOWLEDGE_BASE_SOURCE.QUESTIONNAIRE
    ? 'AI GRC Q&A'
    : source === KNOWLEDGE_BASE_SOURCE.SAMPLE
    ? 'Sample'
    : 'Unknown'
